// frontend/src/components/Logo.js
// Code-drawn "energin" brand logo: Poppins wordmark in navy + the yellow
// corner-hook accent from the brand mark. Recreated inline (no image asset) so
// it stays crisp at any size and inherits the brand font.
import React from 'react';
import { Link } from 'react-router-dom';

// The yellow right-angle "hook" from the logo — hangs at the bottom-right of
// the wordmark as an accent (absolutely positioned so it reads as a mark, not a
// trailing letter).
function Hook({ size }) {
  const s = size * 0.5;
  return (
    <svg width={s} height={s} viewBox="0 0 14 14" aria-hidden="true"
      style={{ display: 'block', marginLeft: size * 0.05, marginBottom: -size * 0.04, flexShrink: 0 }}>
      <rect x="1.4" y="0.8" width="3.6" height="12.4" rx="1.5" fill="#FFCB05" />
      <rect x="1.4" y="9.6" width="10"  height="3.6"  rx="1.5" fill="#FFCB05" />
    </svg>
  );
}

// Compact square mark — for the collapsed sidebar (and mirrors the favicon).
export function LogoMark({ size = 30 }) {
  return (
    <div style={{
      width: size, height: size, background: 'var(--navy-600)', borderRadius: size * 0.24,
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, position: 'relative',
    }}>
      <span style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: size * 0.56, color: '#fff', lineHeight: 1 }}>e</span>
      <svg width={size * 0.34} height={size * 0.34} viewBox="0 0 14 14" aria-hidden="true"
        style={{ position: 'absolute', right: size * 0.12, bottom: size * 0.16 }}>
        <rect x="1.4" y="0.8" width="3.4" height="12.4" rx="1.4" fill="#FFCB05" />
        <rect x="1.4" y="9.8" width="10"  height="3.4"  rx="1.4" fill="#FFCB05" />
      </svg>
    </div>
  );
}

// Full clickable wordmark. `variant="light"` for dark backgrounds (login).
// `to` defaults to the dashboard so the logo is a home link everywhere.
export default function Logo({ size = 22, variant = 'dark', to = '/', tagline, onClick }) {
  const wordColor = variant === 'light' ? '#FFFFFF' : 'var(--navy-600)';
  const inner = (
    <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 3 }}>
      <span style={{ display: 'inline-flex', alignItems: 'flex-end' }}>
        <span style={{
          fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: size,
          color: wordColor, letterSpacing: '-0.035em', lineHeight: 1,
        }}>energin</span>
        <Hook size={size} />
      </span>
      {tagline && (
        <span style={{
          fontSize: size * 0.42, letterSpacing: '0.12em', textTransform: 'uppercase',
          color: variant === 'light' ? 'rgba(255,255,255,0.7)' : 'var(--text-3)', fontWeight: 500,
        }}>{tagline}</span>
      )}
    </span>
  );

  if (!to) return <span aria-label="energin">{inner}</span>;
  return (
    <Link to={to} onClick={onClick} aria-label="energin — home"
      style={{ display: 'inline-flex', textDecoration: 'none' }}>
      {inner}
    </Link>
  );
}
